


import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import PresetGallery from '@/components/PresetGallery/index.vue';
import PresetNavigation from '@/components/PresetNavigation/index.vue';
import DirectCodeInput from '../../components/DirectCodeInput/index.vue';
import { HouseConfiguration, Preset } from '../../utils/api';
import PageTransitionMode from '@/utils/mixins/pageTransitionMode';
import { RouteNames } from '@/utils/router/router.models';
import { tRoute } from '@/utils/plugins/i18nRoutes';
import { Notification, NotificationType } from '@/components/NotificationBanner/NotificationBanner.models';

const homeModule = namespace('home');
const configurationModule = namespace('configuration');
const notifyModule = namespace('notify');

@Component({
  mixins: [PageTransitionMode],
  components: {
    PresetGallery,
    DirectCodeInput,
    PresetNavigation
  }
})
export default class Home extends Vue {
  @homeModule.State private presets!: Preset[];
  @homeModule.Getter private numberOfPresets!: number;

  @configurationModule.Action private setFromNull!: (value: boolean) => Promise<void>;
  @configurationModule.Action private setConfigurationByCode!: ({
    code,
    track
  }: {
    code: string;
    track: boolean;
  }) => Promise<HouseConfiguration>;
  @configurationModule.State private houseConfiguration!: HouseConfiguration;
  @notifyModule.Action private showNotification!: (data: Notification) => void;
  @notifyModule.Action private closeNotification!: (key: string) => Promise<void>;

  private async submitCode(code: string, track = true) {
    const configuration: HouseConfiguration = await this.setConfigurationByCode({ code, track });

    if (configuration) {
      this.startConfiguration();
    } else {
      this.onCodeError();
    }
  }

  private onCodeError() {
    this.showNotification({
      headline: this.$t('components.directCode.error') as string,
      type: NotificationType.Error,
      key: 'OnlineCode/codeInvalid'
    });
  }

  private closeValidationMessage() {
    this.closeNotification('OnlineCode/codeInvalid');
  }

  private async onPresetSelected(preset: Preset) {
    await this.submitCode(preset.configuration.baufritzCode, false);
    // order matters to be sure that the code is sent before the event is tracked
    this.$gtm.trackConfigurationStarted(preset.tracking);
  }

  private startConfiguration(fromNull = false) {
    // let preset: string | undefined;
    if (fromNull) {
      this.setFromNull(true);
      // order matters to be sure that the code is sent before the event is tracked
      this.$gtm.trackConfigurationStarted('msgh_house_individual');
    }

    this.$router.push(tRoute(RouteNames.HouseSize));
  }
}
